import type { AxiosRequestConfig } from 'axios'
import { http, upload, type HttpUploadParams } from '../http'
import { URL } from './_constant'

/**
 * 文件资源-新增
 */
export function API_FILE_ADD(data: ApiFile.Item) {
  return http.post(URL.ADD, data)
}

/**
 * 文件资源-删除
 */
export function API_FILE_DEL(data: IdsPayload) {
  return http.post(URL.DEL, data)
}

/**
 * 文件资源-编辑
 */
export function API_FILE_EDIT(data: BasicUpdateOneReq<ApiFile.Item>) {
  return http.post(URL.EDIT, data)
}

/**
 * 文件资源-列表
 */
export function API_FILE_LIST(data: BasicPageReq) {
  return http.post<BasicPageRes<ApiFile.Item>>(URL.LIST, data)
}

/**
 * 文件资源-全部
 */
export function API_FILE_ALL(data?: BasicPageReq) {
  return http.post<ApiFile.Item[]>(URL.LIST, data)
}

/**
 * 文件资源-详情
 */
export function API_FILE_DETAIL(id: string) {
  return http.post<ApiFile.Item>(URL.DETAIL, { id })
}

/**
 * 文件资源-排序
 */
export function API_FILE_ORDER(data: BasicOrderData) {
  return http.post(URL.ORDER, data)
}

/**
 * 文件资源-禁用
 */
export function API_FILE_DISABLE(data: IdsPayload) {
  return http.post(URL.DISABLE, data)
}

/**
 * 文件资源-启用
 */
export function API_FILE_ENABLE(data: IdsPayload) {
  return http.post(URL.ENABLE, data)
}

/**
 * 文件资源-上传
 */
export function API_FILE_UPLOAD(params: HttpUploadParams, config: AxiosRequestConfig = {}) {
  return upload<ApiFile.Item>(URL.UPLOAD, params, config)
}
